import * as React from 'react';
import { observer } from 'mobx-react';
import { inject } from 'mobx-react';
import { HomePageState } from '../../../containers/home/states/HomePageState';
import './monthlyGoal.module.scss';
import { BackButtonHeader } from './BackButtonHeader';
import { V3Routes } from '../../../routes';
import { Button } from '../../../../commonv3/components/atoms/buttons/Button';
import { FormInput } from '../../atoms/forms/FormInput';
import { MonthlyGoalPaneState } from './states/MonthlyGoalPaneState';
import { observable } from 'mobx';
import { FormState } from '../../../../mainv2/states/FormState';
import { parseQueryParams } from '../../../types/location';
import { GlobalStatesV3 } from '../../../../commonv3/states/GlobalStatesV3';
import { CancelButtonHeader } from '../mypage/CancelButtonHeader';
import { ChevronDown } from './images/Chevron';
import { Check } from './images/Check';

type ListElementFormInputProps = {
    name: string;
    formState: FormState<any>;
    index: number;
    onSetValue: (value) => void;
};

const ListElementFormInput = (props: ListElementFormInputProps) => {
    const { name, formState, index, onSetValue } = props;
    const values = formState.getValue(name);
    return (
        <FormInput
            styleName="list-element"
            name={`${name}-${index}}`}
            value={values[index]}
            placeholder="クリックして追加"
            onChange={(e) => {
                const newValues = [...formState.getValue(name)];
                if (e.target.value) {
                    newValues[index] = e.target.value;
                } else {
                    newValues.splice(index, 1);
                }
                if (newValues[newValues.length - 1] !== '') {
                    newValues.push('');
                }
                onSetValue(newValues);
            }}
        />
    );
};

type Props = {
    homeState: HomePageState;
};

@inject('homeState')
@observer
export class MonthlyGoalPane extends React.Component<Props> {
    @observable pageState = null;

    constructor(props) {
        super(props);
        this.pageState = new MonthlyGoalPaneState(this.props.homeState);
    }

    componentDidMount(): void {
        const { year, month } = parseQueryParams(GlobalStatesV3.routing.location);
        if (year && month) {
            this.pageState.init(year, month);
        } else {
            const today = new Date();
            this.pageState.init(today.getFullYear(), today.getMonth() + 1);
        }
    }

    render() {
        const { submitting, formState, monthlyGoals, month, submitted } = this.pageState;
        const months = monthlyGoals.getOrElse([]);
        const today = new Date();
        if (!months.some((month) => month.year === today.getFullYear() && month.month === today.getMonth() + 1)) {
            months.push({ year: today.getFullYear(), month: today.getMonth() + 1 });
        }
        return (
            <div styleName="pane">
                {GlobalStatesV3.viewport.isDesktop && <BackButtonHeader to={V3Routes.goals()} />}
                {GlobalStatesV3.viewport.isSp && <CancelButtonHeader to={V3Routes.goals()} />}
                <div styleName="h1">
                    <div styleName="select-wrap">
                        <select
                            id="month"
                            name="month"
                            value={month}
                            onChange={(e) => this.pageState.selectMonth(e.target.value)}
                            styleName="select"
                        >
                            {months.map((month) => (
                                <option key={`${month.year}-${month.month}`} value={`${month.year}-${month.month}`}>
                                    {month.year !== today.getFullYear() && `${month.year}年`}
                                    {month.month}月
                                </option>
                            ))}
                        </select>
                        <ChevronDown />
                    </div>
                    <span styleName="text">の目標</span>
                </div>
                <div styleName="section">
                    <div styleName="h2">目標の入力</div>
                    <div styleName="subsection">
                        <div styleName="h3">今月の目標</div>
                        <FormInput
                            styleName="goal"
                            type="textarea"
                            name="goal"
                            value={formState.getValue('goal')}
                            placeholder="今月の目標"
                            onChange={(e) => this.pageState.setFormValue('goal', e.target.value)}
                        />
                    </div>
                    <div styleName="subsection">
                        <div styleName="h3">今月やること</div>
                        <ul styleName="list">
                            {formState.getValue('todos').map((todo, i) => (
                                <li key={`todo-${i}}`}>
                                    <div styleName="bullet" />
                                    <ListElementFormInput
                                        name="todos"
                                        formState={formState}
                                        index={i}
                                        onSetValue={(value) => this.pageState.setFormValue('todos', value)}
                                    />
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
                <div styleName="section">
                    <div styleName="h2">目標の振り返り</div>
                    <div styleName="subsection">
                        <div styleName="h3">目標の達成度</div>
                        <div styleName="progress-wrapper">
                            <FormInput
                                styleName="progress"
                                type="number"
                                name="progress"
                                value={String(formState.getValue('progress'))}
                                placeholder="100"
                                onChange={(e) => this.pageState.setFormValue('progress', parseInt(e.target.value))}
                            />
                            <div styleName="percent">%</div>
                        </div>
                    </div>
                    <div styleName="subsection">
                        <div styleName="h3">自己評価</div>
                        <FormInput
                            styleName="reviews"
                            type="textarea"
                            name="reviews"
                            value={formState.getValue('reviews')}
                            placeholder="自己評価"
                            onChange={(e) => this.pageState.setFormValue('reviews', e.target.value)}
                        />
                    </div>
                    <div styleName="subsection">
                        <div styleName="h3">今月やること</div>
                        <ul styleName="list">
                            {formState.getValue('next_actions').map((review, i) => (
                                <li key={`next_action-${i}}`}>
                                    <div styleName="bullet" />
                                    <ListElementFormInput
                                        name="next_actions"
                                        formState={formState}
                                        index={i}
                                        onSetValue={(value) => this.pageState.setFormValue('next_actions', value)}
                                    />
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
                <div styleName="submit-button-wrapper">
                    {submitted ? (
                        <div styleName="submitted-wrapper">
                            <div styleName="checked-icon">
                                <Check />
                            </div>
                            <div styleName="submitted-text">保存しました</div>
                            <div styleName="dummy" />
                        </div>
                    ) : (
                        <Button
                            styleName="submit-button"
                            type="primary"
                            size="m"
                            disabled={submitting}
                            onClick={() => this.pageState.submit()}
                        >
                            保存する
                        </Button>
                    )}
                </div>
            </div>
        );
    }
}
